export const MAX_ITEMS_TO_SHOW = 5;
